import React from "react";

const formatDate = (value) => {
  if (!value) {
    return <span>-</span>;
  }

  const date = new Date(`${value}T00:00:00`);
  const months = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  return (
    <span title={value}>
      {`${date.getDate()} de ${months[date.getMonth()]}`}
    </span>
  );
};

export { formatDate };
